import numeral from 'numeral'
import React, { useEffect } from 'react'
import { useState } from 'react'
import { RowRender } from '../Controles/RowRender'
import { InicioMobileAsync, ObtenerEstatusCuentaAsync } from '../Servicios/ServiciosPublicos'

export const MonedasRender = (params) => {

    //#region internalState
    const [internalState, setInternalState] = useState({
        InicioMobile: {
            Saldo: 0,
            Detalle: []
        },
        Cliente: {
            client_id: 0,
            first_name: "",
            email_stored: "",
        },
        objInterval: null,
    })
    //#endregion
    //#region useEffect
    useEffect(() => {
        Load();
        const _objInt = setInterval(() => { ObtenerInicioMobile(); }, 10000);
        return () => { if (_objInt) { clearInterval(_objInt); } };
    }, [])
    //#endregion
    //#region Metodos
    const Load = async () => {
        ObtenerInicioMobile();
        ObtenerDatosCliente();
    }
    const ObtenerInicioMobile = async () => {
        let _w = +window.innerWidth;
        if (_w < 767) {
            let inicio = await InicioMobileAsync();
            setInternalState((state) => { return { ...state, InicioMobile: inicio } });
        }
    }
    const ObtenerDatosCliente = async () => {
        let _info = await ObtenerEstatusCuentaAsync();
        setInternalState((state) => ({ ...state, Cliente: _info }));
    }
    const OnClickItem = (item) => {
        if (params.OnMonedaDetalleChange) {
            params.OnMonedaDetalleChange({ Item: item, Detalle: [] })
        }
    }
    //#endregion

    return (
        <>
            <div className="principal-mobile-header">
                <div className="titulo">{`${internalState.Cliente.first_name} ${internalState.Cliente.last_name} `}</div>
                <div className="titulo">{`${internalState.Cliente.email_stored} `}</div>
                <div className="amount">{numeral(internalState.InicioMobile.Saldo).format("0,000.00")}</div>
            </div>
            <div className="principal-mobile-detalle">
                {internalState.InicioMobile.Detalle.map((item, i) => (<RowRender index={i} Item={item} onClick={OnClickItem} />))}
            </div>
        </>
    )
}
